import moment from 'moment';
import { WhatsNewEntry } from '@src/dtos/whats-new.dto';

export const WHATS_NEW_RETENTION_DAYS = 90;

/**
 * Returns only entries whose releaseDate is within the last 90 days.
 * Entries are expected to be in descending order (newest first).
 */
export function filterToRetentionWindow(entries: readonly WhatsNewEntry[]): WhatsNewEntry[] {
  const cutoff = moment.utc().subtract(WHATS_NEW_RETENTION_DAYS, 'days');
  return entries.filter(entry => moment.utc(entry.releaseDate).isAfter(cutoff));
}

/**
 * Returns true when any entry in the retention window is newer than lastSeenDate.
 * If lastSeenDate is null/invalid, any visible entry counts as unread.
 */
export function hasUnreadEntries(
  entries: readonly WhatsNewEntry[],
  lastSeenDate: moment.Moment | null,
): boolean {
  const visible = filterToRetentionWindow(entries);
  if (!lastSeenDate?.isValid()) return visible.length > 0;
  return visible.some(entry => moment.utc(entry.releaseDate).isAfter(lastSeenDate));
}
